import { APIHelper } from '@archistarai/auth-frontend';
import Vue from 'vue';

export default {
  state: {
    companies: []
  },
  getters: {
    get: (state) => (guid) => {
      return state.companies.find((u) => u.guid === guid);
    }
  },
  mutations: {
    ADD_TO_COMPANIES(state, company) {
      let index = state.companies.findIndex((c) => c.guid === company.guid);
      if (index < 0) {
        state.companies.push(company);
      } else {
        Vue.set(state.companies, index, company);
      }
    }
  },
  actions: {
    async getCompany({ commit, getters }, payload) {
      if (!payload.forceNew && getters.get(payload.guid)) {
        // if cached in state return
        return getters.get(payload.guid);
      }
      try {
        const { data } = await APIHelper.AdminAPI.get(`/companies/${payload.guid}`);
        commit('ADD_TO_COMPANIES', data.data);
        return data.data;
      } catch (e) {
        throw e;
      }
    }
  }
};
